import {
	GET_ACCESS_ROLE,
	GET_ACCESS_ROLE_ERROR,
	GET_ACCESS_ROLE_SUCCESS,
} from '../../constants';

export const getAccessRoleReducer = (state, actions) => {
	switch (actions.type) {
		case GET_ACCESS_ROLE:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
			};
		case GET_ACCESS_ROLE_ERROR:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
			};
		case GET_ACCESS_ROLE_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				accessRole: actions.payload,
			};
		default:
			return state;
	}
};
